export default __webpack_public_path__ + "static/media/shape2.07075f03.svg";